import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandM } from '@sorare/core/src/atoms/typography';
import { NeonEdge } from '@sorare/core/src/atoms/ui/NeonEdge';
import { TextureBackground } from '@sorare/core/src/atoms/ui/TextureBackground';
import { Bezel } from '@sorare/core/src/atoms/ui/bezels/Bezel';

import pick from 'components/essence/CardPullExperience/CardPullRulesDialog/HowItWorks/assets/pick.png';

const Content = styled(Vertical)`
  height: 100%;
  padding: var(--triple-unit) var(--quadruple-unit) 0;
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const StyledNeonEdge = styled(NeonEdge)`
  position: absolute;
  inset: 0;
`;

const StyledTextureBackground = styled(TextureBackground)`
  position: absolute;
  inset: 0;
  z-index: -1;
`;

export const PickACard = () => {
  return (
    <Bezel borderColor="rgba(var(--c-rgb-limited), 0.3)">
      <StyledTextureBackground
        background="wave2"
        mode="dark"
        color={['var(--c-black)', 'rgba(var(--c-rgb-black), 0)']}
        imageOpacity={0.3}
        withDots
      />
      <Content center gap={4}>
        <BrandM>
          <FormattedMessage
            id="PickACard.title"
            defaultMessage="Pick the right card"
          />
        </BrandM>
        <Img src={pick} alt="" />
      </Content>
      <StyledNeonEdge
        color="var(--c-limited-primary)"
        showNeon="always"
        showHalo="always"
      />
    </Bezel>
  );
};
